function o(){var o;return"production"===(null===(o=process)||void 0===o||null===(o=o.env)||void 0===o?void 0:o.NODE_ENV)}export{o as isProd};
